import { createReducer } from 'redux-starter-kit';

import { ProductsReducerType } from './reports.types';
import {
  SET_REPORTS_TABLES,
  CLEAR_REPORTS_TABLES,
  CLEAR_REPORTS_HTMLS,
  SET_REPORTS_HTMLS,
} from './reports.actions';

const initialState: ProductsReducerType = {
  tables: {
    count: -1,
    next: '',
    previous: '',
    results: [],
  },
  htmls: {
    count: -1,
    next: '',
    previous: '',
    results: [],
  },
};

export default createReducer(initialState, {
  [SET_REPORTS_TABLES]: (state, action) => {
    state.tables = action.payload;
  },
  [CLEAR_REPORTS_TABLES]: (state) => {
    state.tables = initialState.tables;
  },
  [SET_REPORTS_HTMLS]: (state, action) => {
    state.htmls = action.payload;
  },
  [CLEAR_REPORTS_HTMLS]: (state) => {
    state.htmls = initialState.htmls;
  },
});
